<template>
  <div
    class="bg-bgr-secondary flex h-12 w-full items-center rounded-xl px-4 py-3 transition-all duration-300"
    :class="disabled ? 'cursor-not-allowed opacity-60' : 'hover:bg-bgr-secondary cursor-pointer'"
    @click="() => !disabled && (parentClicked = !parentClicked)"
  >
    <p class="text-body-default-m">{{ text }}</p>
    <Toggle
      class="ml-auto"
      :parent-clicked="parentClicked"
      :name="name"
      :disabled="disabled"
      @click.stop=""
      @update:model-value="
        (val) => {
          ((inputValue = val), emitUpdate(val));
        }
      "
    />
  </div>
</template>

<script setup lang="ts">
  const emit = defineEmits(["update:modelValue"]);

  withDefaults(
    defineProps<{
      text?: string;
      name?: string;
      disabled?: boolean;
    }>(),
    {
      text: "",
      name: "",
      disabled: false,
    }
  );

  const parentClicked = ref(false);

  const emitUpdate = (val) => {
    emit("update:modelValue", val);
  };
</script>
